import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { TrendingUp, Shield, Zap, BarChart3, CreditCard } from 'lucide-react';
import multiLang from 'assets/images/loginPageImages/multiLang.svg';
import socialHub from 'assets/images/loginPageImages/socialHub.svg';
import payment from 'assets/images/loginPageImages/payment.svg';
import child from 'assets/images/loginPageImages/child.svg';

const Carousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: multiLang,
      icon: <TrendingUp className="w-8 h-8 text-blue-500" />,
      title: "AI-BasedMultilingual Communication Engine",
      description: "Lorem ipsum dolor sit amet consectetur. Cursus scelerisque turpis pretium quis ac est vitae iaculis interdum.",
      stats: {
        collections: { value: "12,35,000", change: "+1,05,000" },
        overduePayments: { value: "12", status: "Detected High Risk" },
        autoCollections: { value: "1,55,000", period: "This Month" }
      }
    },
    {
      id: 2,
      image: socialHub,
      icon: <Shield className="w-8 h-8 text-green-500" />,
      title: "AI-Based Social Hub",
      description: "Lorem ipsum dolor sit amet consectetur. Cursus scelerisque turpis pretium quis ac est vitae iaculis interdum. ",
      stats: {
        collections: { value: "15,42,000", change: "+2,15,000" },
        overduePayments: { value: "8", status: "Low Risk Detected" },
        autoCollections: { value: "2,25,000", period: "This Month" }
      }
    },
    {
      id: 3,
      image: payment,
      icon: <Zap className="w-8 h-8 text-yellow-500" />,
      title: "AI-Based Fee Collection",
      description: "Lorem ipsum dolor sit amet consectetur. Cursus scelerisque turpis pretium quis ac est vitae iaculis interdum. ",
      stats: {
        collections: { value: "18,67,000", change: "+3,25,000" },
        overduePayments: { value: "5", status: "Minimal Risk" },
        autoCollections: { value: "2,85,000", period: "This Month" }
      }
    },
    {
      id: 4,
      image: child,
      icon: <BarChart3 className="w-8 h-8 text-purple-500" />,
      title: "AI-Child Counseling Podcasts",
      description: "Lorem ipsum dolor sit amet consectetur. Cursus scelerisque turpis pretium quis ac est vitae iaculis interdum. ",
      stats: {
        collections: { value: "21,45,000", change: "+4,12,000" },
        overduePayments: { value: "3", status: "Very Low Risk" },
        autoCollections: { value: "3,15,000", period: "This Month" }
      }
    }/* ,
    {
      id: 5,
      icon: <CreditCard className="w-8 h-8 text-indigo-500" />,
      title: "Multi-Payment Gateway",
      description: "Support for multiple payment methods and gateways ensuring maximum convenience for your customers.",
      stats: {
        collections: { value: "24,89,000", change: "+5,67,000" },
        overduePayments: { value: "1", status: "Excellent Status" },
        autoCollections: { value: "3,95,000", period: "This Month" }
      }
    } */
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const cardVariants = {
    enter: {
      x: 300,
      opacity: 0,
      scale: 0.9
    },
    center: {
      x: 0,
      opacity: 1,
      scale: 1
    },
    exit: {
      x: -300,
      opacity: 0,
      scale: 0.9
    }
  };

  const textVariants = {
    enter: {
      y: 20,
      opacity: 0
    },
    center: {
      y: 0,
      opacity: 1,
      transition: {
        delay: 0.3,
        duration: 0.5
      }
    },
    exit: {
      y: -20,
      opacity: 0
    }
  };

  return (
    <div className="flex items-center justify-center p-4">
      <div className="w-full">
        {/* Card Container */}
          <AnimatePresence mode="wait">
            <motion.div
              key={currentSlide}
              variants={cardVariants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{
                type: "spring",
                stiffness: 300,
                damping: 30
              }}
              className='flex justify-center'
            >
              <img src={slides[currentSlide].image} alt={slides[currentSlide].title} className='object-cover' />
              {/* <div className="bg-white rounded-2xl p-6 shadow-2xl h-full">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-gray-600 text-sm font-medium">Payment Insights</h3>
                  <button className="text-gray-400 hover:text-gray-600">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                <div className="space-y-4">
                  <div className="flex justify-between items-start">
                    <div>
                      <p className="text-xs text-gray-500 mb-1">Protected Collections (Net 30 Days)</p>
                      <p className="text-xl font-bold text-gray-900">{slides[currentSlide].stats.collections.value}</p>
                    </div>
                    <div className="text-right">
                      <span className="text-green-500 text-sm font-medium">{slides[currentSlide].stats.collections.change}</span>
                      <div className="bg-blue-100 text-blue-600 px-2 py-1 rounded text-xs mt-1">
                        View
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <div>
                      <p className="text-xs text-gray-500 mb-1">Overdue Payments (AI Detected High Risk)</p>
                      <p className="text-xl font-bold text-gray-900">{slides[currentSlide].stats.overduePayments.value}</p>
                    </div>
                    <div className="bg-blue-100 text-blue-600 px-2 py-1 rounded text-xs">
                      View
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <div>
                      <p className="text-xs text-gray-500 mb-1">Successful Auto Collections (This Month)</p>
                      <p className="text-xl font-bold text-gray-900">{slides[currentSlide].stats.autoCollections.value}</p>
                    </div>
                    <div className="bg-blue-100 text-blue-600 px-2 py-1 rounded text-xs">
                      View
                    </div>
                  </div>

                  <div className="pt-2">
                    <p className="text-xs text-gray-400">
                      AI actively monitoring. Automatic payments.
                    </p>
                    <p className="text-xs text-gray-400">
                      Review • Flags • Incidents
                    </p>
                  </div>
                </div>
              </div> */}
            </motion.div>
          </AnimatePresence>

        {/* Title and Description */}
        <AnimatePresence mode="wait">
          <motion.div
            key={`text-${currentSlide}`}
            variants={textVariants}
            initial="enter"
            animate="center"
            exit="exit"
            className="text-center mb-8"
          >
            {/* <div className="flex justify-center mb-4">
              {slides[currentSlide].icon}
            </div> */}
            <h2 className="text-white text-2xl font-bold mb-4">
              {slides[currentSlide].title}
            </h2>
            <p className="text-purple-100 text-sm leading-relaxed px-4">
              {slides[currentSlide].description}
            </p>
          </motion.div>
        </AnimatePresence>

        {/* Circular Indicators */}
        <div className="flex justify-center space-x-2">
          {slides.map((_, index) => (
            <motion.button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentSlide
                  ? 'bg-white'
                  : 'bg-white/30 hover:bg-white/50'
              }`}
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carousel;